// extracted by mini-css-extract-plugin
export var borderRadius = "_f8-4";
export var large = "_f8-3";
export var logoContainer = "_f8-0";
export var nameLogo = "_f8-2";
export var small = "_f8-1";